import script from "./ProjectRevenuesPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectRevenuesPage.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectRevenuesPage.vue?vue&type=style&index=0&id=0d8e1848&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d8e1848"]])

export default __exports__